<template>
  <div class="key_visual addImg noti">
    <div class="container">
      <p>공지사항</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShowTitle',
}
</script>
